<template>
  <div class="h-dialogContainer">
    <form id="k8sEnvForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('环境名称')}}</div>
              <input
                class="e-input e-input-group"
                name="k8sEnvName"
                v-model="k8sEnvName"
                maxlength="20"
                :placeholder="$t('请输入环境名称')"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{this.$t('IP')}}</div>
              <input
                class="e-input e-input-group"
                v-model="k8sEnvIp"
                name="k8sEnvIp"
                :placeholder="$t('请输入IP')"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{this.$t('端口')}}</div>
              <input
                class="e-input e-input-group"
                v-model="k8sEnvPort"
                name="k8sEnvPort"
                :placeholder="$t('请输入端口')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{this.$t('授权码')}}</div>
              <ejs-textbox
                class="e-input e-input-group"
                multiline="true"
                v-model="k8sAuthCode"
                name="k8sAuthCode"
                :placeholder="$t('请输入授权码')"
              />
            </div>
          </div>
        </div>

        <!-- <div class='row h-row-insertBox'>
        <div class='col-sm-6 h-col-insertBox'>
          <ejs-button cssClass="e-small" :isPrimary="true" @click.native="checkAuthCode">{{$t('验证')}}</ejs-button>
                  
        </div>
        </div>-->
      </div>
    </form>
  </div>
</template>

<script>
import { EventBus } from "../../../plugins/eventBus";
import mixin from "../../../mixin/mixin";

export default {
  name: "editDialog",
  mixins: [mixin],

  data() {
    return {
      k8sEnvName: "",
      k8sEnvIp: "",
      k8sEnvPort: "",
      k8sAuthCode: "",
      k8sLabels: "",
      k8sTaints: "",
      id: "",
      formObj: "",
      inputNames: ["k8sEnvName", "k8sEnvIp", "k8sEnvPort", "k8sAuthCode"],
      inputNames: ["k8sEnvIp"],
      editFlagCheckAuthCode: false,
      editFlagCheckIpRepeat: false,

      rules: {
        k8sAuthCode: {
          required: true
        },
        k8sEnvName: {
          required: true,
          maxLength: 30
        },
        k8sEnvIp: { required: true, regex: "ipv4" },
        k8sEnvPort: {
          required: true,
          regex: "integer",
          min: 1,
          max: 65535
        }
      }
    };
  },
  methods: {
    clear() {
      this.k8sEnvName = "";
      this.k8sEnvIp = "";
      this.k8sEnvPort = "";
      this.k8sAuthCode = "";
    },
    findEnv(data) {
      this.id = data.id;
      this.k8sEnvName = data.k8sName;
      this.k8sAuthCode = data.k8sAuthCode;
      this.k8sEnvIp = data.k8sEnvIp;
      this.k8sEnvPort = data.k8sEnvPort;
      this.k8sName = data.k8sName;
      this.k8sLabels = data.k8sLabels;
      this.k8sTaints = data.k8sTaints;
    },
    getData() {
      return {
        name: this.k8sEnvName,
        type: "5G",
        id: this.id,
        content: {
          k8sEnvIp: this.k8sEnvIp,
          k8sEnvPort: this.k8sEnvPort,
          k8sAuthCode: this.k8sAuthCode,
          k8sLabels: this.k8sLabels,
          k8sTaints: this.k8sTaints
        }
      };
    },
    async checkAuthCode() {
      const params = this.getData();
      await this.$axios
        .post("/lte/ems/env/checkEnvironment.html", params)
        .then(response => {
          console.log(response);
          if (response && response.status === 200) {
            if (response.data.errorCode === "SUCCESS") {
              this.editFlagCheckAuthCode = true;
              return true;
            } else {
              this.$loading.hideLoadding();
              EventBus.$emit("toast", {
                type: "warning",
                content: "授权码验证失败"
              });
              this.editFlagCheckAuthCode = false;
              return false;
            }
          } else {
            this.$loading.hideLoadding();
            EventBus.$emit("toast", {
              type: "warning",
              content: "授权码验证失败"
            });
            this.editFlagCheckAuthCode = false;
            return false;
          }
        });
    },
    async checkIpRepeat() {
      this.editFlagCheckIpRepeat = false;
      if (!this.validate()) {
        return false;
      }
      this.$loading.showLoadding('环境修改中','请稍后');
      const params = {
        id: this.id,
        type: "5G",
        ip: this.k8sEnvIp
      };
      await this.$axios
        .post("/lte/ems/env/checkEnvIp.html", params)
        .then(response => {
          console.log(response);
          if (response && response.status === 200) {
            if (response.data.errorCode === "SUCCESS") {
              this.editFlagCheckIpRepeat = true;
              return true;
            } else {
              this.$loading.hideLoadding();
              EventBus.$emit("toast", {
                type: "warning",
                content: "IP重复"
              });
              this.editFlagCheckIpRepeat = false;
              return false;
            }
          } else {
            this.$loading.hideLoadding();
            EventBus.$emit("toast", {
              type: "warning",
              content: "IP验证失败"
            });
            this.editFlagCheckIpRepeat = false;

            return false;
          }
        });
    },
    bindValidate() {
      this.formObj = this.validateForm(
        "k8sEnvForm",
        this.inputNames,
        this.rules
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  eventEmit(type, content) {
    EventBus.$emit("toast", { type: type, content: content });
  }
  // mounted() {
  //   this.bindValidate();
  // }
};
</script>
